"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SealedConditionalSchema = exports.ConditionalSchema = exports.ConditionalValue = void 0;
const codegen_1 = require("@azure-tools/codegen");
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class ConditionalValue extends codegen_1.Initializer {
    constructor(name, description, source, target, objectInitializer) {
        super();
        this.target = target;
        this.source = source;
        this.language = {
            default: {
                name,
                description,
            },
        };
        this.apply(objectInitializer);
    }
}
exports.ConditionalValue = ConditionalValue;
class ConditionalSchema extends schema_1.Schema {
    constructor(name, description, sourceValue, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Conditional);
        this.sourceValue = sourceValue;
        this.apply(objectInitializer);
    }
}
exports.ConditionalSchema = ConditionalSchema;
class SealedConditionalSchema extends schema_1.Schema {
    constructor(name, description, sourceValue, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.SealedConditional);
        this.sourceValue = sourceValue;
        this.apply(objectInitializer);
    }
}
exports.SealedConditionalSchema = SealedConditionalSchema;
//# sourceMappingURL=conditional.js.map